var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "name",
          class: {
            required: _vm.field.required,
          },
        },
        [_vm._v(" " + _vm._s(_vm.field.name) + " ")]
      ),
      _c(
        "div",
        _vm._l(_vm.variants, function (variant) {
          return _c(
            "div",
            { key: variant.id, staticClass: "variant" },
            [
              _c("c-radio", {
                attrs: {
                  value: variant.id === _vm.localValue,
                  label: variant.text,
                  type: "radio",
                  "name-radio-group": `field-radio-${_vm._uid}`,
                },
                on: {
                  input: function ($event) {
                    return _vm.updateValue($event, variant.id)
                  },
                },
              }),
            ],
            1
          )
        }),
        0
      ),
      _vm.error
        ? _c("error-feedback", { attrs: { text: _vm.error } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }